<div ngbDropdown class="vox-dropdown-input">
  <button type="button" ngbDropdownToggle>{{selectedRatings}}</button>
  <div ngbDropdownMenu>
    <button type="button" ngbDropdownItem *ngFor="let rating of RATINGS"
      (click)="selectRating(rating)">{{rating}}</button>
  </div>
</div>